import Style from "./stye"

import Search from "widget/Search"
import Pagenation from "widget/Pagenation"

import useGetSeriesList from "entity/series/useGetSeriesList"

import DefaultModal from "shared/ui/DefaultModal"
import DefaultButton from "shared/ui/DefaultButton"
import TStyle from "shared/style/tableStyle"
import timestampCalculator from "shared/lib/timestampCalculator"

const SeriesModal = ({ closeEvent, setSeriesData }) => {

    const [seriesList] = useGetSeriesList()

    const sizeList = ["short", "expand", "medium", "medium", "medium"]
    const tableHeadList = ["IDX", "대회 시리즈 이름", "시작 날짜", "종료 날짜", ""]

    const selectSeriesEvent = (data) => {
        setSeriesData(data)
        closeEvent()
    }

    return (
        <DefaultModal title={"대회 시리즈 검색"} closeEvent={closeEvent}>
            <Style.Wrapper>
                <Search placeholder="대회 시리즈 이름에 포함되는 글자로 검색" />

                <TStyle.TableDiv>
                    <TStyle.TableRow $title>
                        {tableHeadList.map((elem, index) =>
                            <TStyle.Data $title $size={sizeList[index]}>{elem}</TStyle.Data>
                        )}
                    </TStyle.TableRow>
                    {seriesList?.data?.series_list?.map((elem, index) =>
                        <TStyle.TableRow $odd={index % 2 === 1}>
                            <TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
                            <TStyle.Data $size={sizeList[1]}>{elem?.name}</TStyle.Data>
                            <TStyle.Data $size={sizeList[2]}>{timestampCalculator(elem?.start_date, "date")}</TStyle.Data>
                            <TStyle.Data $size={sizeList[3]}>{timestampCalculator(elem?.end_date, "date")}</TStyle.Data>
                            <TStyle.Data $size={sizeList[4]}>
                                <DefaultButton small fitWidth clickEvent={() => selectSeriesEvent(elem)}>선택하기</DefaultButton>
                            </TStyle.Data>
                        </TStyle.TableRow>
                    )}
                </TStyle.TableDiv>

                <Pagenation maxPage={1} />
            </Style.Wrapper>
        </DefaultModal>
    )
}

export default SeriesModal